// extracted by mini-css-extract-plugin
export default {"body":"GenericConfirmationModal_body__i97ey","confirmButton":"GenericConfirmationModal_confirmButton__EAvpa","modal":"GenericConfirmationModal_modal__GhAef"};